<script lang="ts">
  import ControlBarMobile from '../ControlBarMobile.svelte'
  import FullscreenButton from '../buttons/FullscreenButton.svelte'
  import VolumeButton from '../buttons/VolumeButton.svelte'
  import ChromecastButton from '../buttons/ChromecastButton.svelte'
  import LiveIndicator from './LiveIndicator.svelte'
</script>

<ControlBarMobile>
  <ChromecastButton />
  <FullscreenButton />
  <VolumeButton />
  <LiveIndicator />
</ControlBarMobile>
